import React from 'react';

import type { Meta, Reference } from '@swf/cms';
import { CMSThumbnail, useCMSReference } from '@swf/cms';
import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { Header } from '@swf/core/enums';

import useGeoVisibility from '../CMSContainer/hooks/useGeoVisibility';

const TilesGridItem: React.FC<Reference> = (props) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { thumbnail, visibility_rules } = useCMSReference<Meta>(props) as Meta;
  const [visible, doesVary] = useGeoVisibility(visibility_rules);
  return (
    <>
      {doesVary && <Vary by={[Header.Country]} />}
      {visible ? <CMSThumbnail {...thumbnail} /> : null}
    </>
  );
};

export default TilesGridItem;
